import type { IUserMM } from '../models/IUserMM';

export class UserMM {
  public id: string;
  public birthDate: string;
  public email: string;
  public name: string;
  public phone: string;
  public sex: string;

  constructor(user: IUserMM) {
    this.id = user.id || '';
    this.birthDate = user.birthDate || '';
    this.email = user.email || '';
    this.name = user.firstName || '';
    this.phone = user.phone || '';
    this.sex = user.sex || '';
  }

  public get sexFormatted(): string {
    return this.sex === 'male' ? 'Мужской' : 'Женский';
  }
} 